import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import {
  Participation,
  useParticipationIncentiveText,
  usePublicSession,
} from '@app/api';

import { AppointmentInfoLine } from './AppointmentInfoLine';
import { SessionInformations } from './SessionInformations';
import { LabeledSection } from './LabeledSection';
import { FoldableParagraphSection } from './FoldableParagraphSection';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.marginBase * 3,
    marginBottom: theme.marginBase * 7,
  },
  title: {
    ...theme.fonts.h3,
  },
  content: {
    ...theme.fonts.caption,
    color: theme.colors.inkPrimary,
  },
  sessionInformationsContainer: {
    marginTop: 0,
  },
}));

interface Props {
  participation: Participation;
  title: string;
}

export const ParticipationEditSummary = ({ participation, title }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { data: session } = usePublicSession(
    participation.sessionLinkId || participation.sessionId,
  );

  const incentiveText = useParticipationIncentiveText(participation, session);

  if (!session) {
    return null;
  }

  return (
    <section className={classes.section}>
      <h1 className={classes.title}>{t(title)}</h1>
      <LabeledSection label={t('booking.summary.aboutTheStudy')}>
        <FoldableParagraphSection
          toggleLabel={t('booking.summary.seeDescription')}
          label={session?.title}
        >
          <p className={classes.content}>{session.description}</p>
        </FoldableParagraphSection>
      </LabeledSection>
      <SessionInformations
        incentive={incentiveText}
        studyType={session.studyType}
        className={classes.sessionInformationsContainer}
      />

      {participation.format && (
        <LabeledSection
          label={t('booking.summary.appointmentInfoSectionLable')}
        >
          <AppointmentInfoLine participation={participation} />
        </LabeledSection>
      )}
    </section>
  );
};
